import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IONIC_STORAGE_CONFIG, IONIC_STORAGE_CONFIG_TOKEN } from './core/config/ionic-storage-config';
import { TokenInterceptor } from './core/interceptors/token/token.interceptor';
import { AppointmentAttachmentAddComponent } from './pages/appointment-attachment-add/appointment-attachment-add.component';
import { AppointmentAttachmentListComponent } from './pages/appointment-attachment-list/appointment-attachment-list.component';
import { AppointmentClearCodesComponent } from './pages/appointment-clear-codes/appointment-clear-codes.component';
import { AddChargeComponent } from './pages/appointment-clear-codes/charges-tab/add-charge/add-charge.component';
import { ChargesTabComponent } from './pages/appointment-clear-codes/charges-tab/charges-tab.component';
import { CodesTabComponent } from './pages/appointment-clear-codes/codes-tab/codes-tab.component';
import { NotesTabComponent } from './pages/appointment-clear-codes/notes-tab/notes-tab.component';
import { TimeTabComponent } from './pages/appointment-clear-codes/time-tab/time-tab.component';
import { FormsTabComponent } from './pages/appointment-clear-codes/forms-tab/forms-tab.component';
import { AppointmentDetailsComponent } from './pages/appointment-details/appointment-details.component';
// tslint:disable-next-line: max-line-length
import { AddTruckInventoryModalComponent } from './pages/appointment-inventory/add-truck-inventory-modal/add-truck-inventory-modal.component';
// tslint:disable-next-line: max-line-length
import { AddWarehouseInventoryModalComponent } from './pages/appointment-inventory/add-warehouse-inventory-modal/add-warehouse-inventory-modal.component';
import { AppointmentInventoryComponent } from './pages/appointment-inventory/appointment-inventory.component';
import { EditInventoryComponent } from './pages/appointment-inventory/edit-inventory/edit-inventory.component';
import { InventoryActiveTabComponent } from './pages/appointment-inventory/inventory-active-tab/inventory-active-tab.component';
import { InventoryAddTabComponent } from './pages/appointment-inventory/inventory-add-tab/inventory-add-tab.component';
import { InventoryItemComponent } from './pages/appointment-inventory/inventory-item/inventory-item.component';
import { InventoryModalHeaderComponent } from './pages/appointment-inventory/inventory-modal-header/inventory-modal-header.component';
import { InventoryRemoveTabComponent } from './pages/appointment-inventory/inventory-remove-tab/inventory-remove-tab.component';
// tslint:disable-next-line: max-line-length
import { PrimaryAttributeSearchModalComponent } from './pages/appointment-inventory/primary-attribute-search-modal/primary-attribute-search-modal.component';
import { RemoveInventoryComponent } from './pages/appointment-inventory/remove-inventory/remove-inventory.component';
import { AppointmentLinecardCommentModalComponent } from './pages/appointment-linecard-comment-modal/appointment-linecard-comment-modal.component';
import { AppointmentLinecardListComponent } from './pages/appointment-linecard-list/appointment-linecard-list.component';
// tslint:disable-next-line: max-line-length
import { AppointmentListItemSkeletonComponent } from './pages/appointment-list/appointment-list-item-skeleton/appointment-list-item-skeleton.component';
import { AppointmentListItemComponent } from './pages/appointment-list/appointment-list-item/appointment-list-item.component';
import { AppointmentListComponent } from './pages/appointment-list/appointment-list.component';
import { AppointmentNotesComponent } from './pages/appointment-notes/appointment-notes.component';
import { LoginComponent } from './pages/login/login.component';
import { TimeTrackingFormComponent } from './pages/time-tracking-form/time-tracking-form.component';
import { TimeTrackingListComponent } from './pages/time-tracking-list/time-tracking-list.component';
import { TruckInventoryFilterComponent } from './pages/truck-inventory/truck-inventory-filter/truck-inventory-filter.component';
import { TruckInventoryListComponent } from './pages/truck-inventory/truck-inventory-list/truck-inventory-list.component';
import { ChangeStatusButtonComponent } from './shared/button/change-status-button/change-status-button.component';
import { SyncButtonComponent } from './shared/button/sync-button/sync-button.component';
import { EmptyListItemComponent } from './shared/components/empty-list-item/empty-list-item.component';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { ScrollableTextComponent } from './shared/components/scrollable-text/scrollable-text.component';
import { TimeEntryToggleSectionComponent } from './shared/components/time-entry-toggle-section/time-entry-toggle-section.component';
import { TitledAddToolbarComponent } from './shared/components/titled-add-toolbar/titled-add-toolbar.component';
import { SimpleModalHeaderComponent } from './shared/modal/simple-modal-header/simple-modal-header.component';
import { AppointmentHeaderComponent } from './_layout/appointment-header/appointment-header.component';
import { AppointmentLayoutComponent } from './_layout/appointment-layout/appointment-layout.component';
import { MainHeaderComponent } from './_layout/main-header/main-header.component';
import { MainLayoutComponent } from './_layout/main-layout/main-layout.component';
import { WorkforceFormComponent } from './pages/workforce-form/workforce-form.component';
import { SignaturePadModule } from 'angular2-signaturepad';
4
@NgModule({
	declarations: [
		AppComponent,
		LoginComponent,
		LoaderComponent,
		MainHeaderComponent,
		MainLayoutComponent,
		AppointmentListComponent,
		AppointmentListItemComponent,
		AppointmentListItemSkeletonComponent,
		AppointmentLayoutComponent,
		AppointmentHeaderComponent,
		AppointmentDetailsComponent,
		AppointmentClearCodesComponent,
		AppointmentNotesComponent,
		ChangeStatusButtonComponent,
		CodesTabComponent,
		NotesTabComponent,
		AppointmentAttachmentListComponent,
		AppointmentAttachmentAddComponent,
		ChargesTabComponent,
		AddChargeComponent,
		SimpleModalHeaderComponent,
		TimeTabComponent,
		FormsTabComponent,
		SyncButtonComponent,
		EmptyListItemComponent,
		TimeTrackingListComponent,
		TimeTrackingFormComponent,
		TimeEntryToggleSectionComponent,
		ScrollableTextComponent,
		AppointmentInventoryComponent,
		InventoryActiveTabComponent,
		InventoryAddTabComponent,
		InventoryRemoveTabComponent,
		InventoryItemComponent,
		EditInventoryComponent,
		RemoveInventoryComponent,
		InventoryModalHeaderComponent,
		TitledAddToolbarComponent,
		AddTruckInventoryModalComponent,
		PrimaryAttributeSearchModalComponent,
		AddWarehouseInventoryModalComponent,
		TruckInventoryListComponent,
		TruckInventoryFilterComponent,
		AppointmentLinecardListComponent,
		AppointmentLinecardCommentModalComponent,
		WorkforceFormComponent,
	],
	imports: [
		BrowserModule,
		IonicModule.forRoot(),
		IonicStorageModule.forRoot(),
		FormsModule,
		ReactiveFormsModule,
		HttpClientModule,
		AppRoutingModule,
		ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
		SignaturePadModule
	],
	providers: [
		StatusBar,
		SplashScreen,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: TokenInterceptor,
			multi: true
		},
		{ provide: IONIC_STORAGE_CONFIG_TOKEN, useValue: IONIC_STORAGE_CONFIG, },
		{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
